export const timeString = (timeElapsed: number) => {
  const hours = Math.floor((timeElapsed || 0) / 3600)
  const minutes = Math.floor(((timeElapsed || 0) % 3600) / 60)
  const seconds = (timeElapsed || 0) % 60
  return `${hours > 0 ? `${hours}:` : ''}${hours > 0 ? String(minutes).padStart(2, '0') : minutes}:${String(seconds).padStart(2, '0')}`
}